// extracted by mini-css-extract-plugin
module.exports = {"main":"NewUser_main__2NPXp"};